import { Switch } from '@mantine/core'
import { sendOutput, sendSignal } from '@shared/port-send-v1.0.0'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import type { Props } from '../node/definition'
import IconSvg from '@packages/icon-svg'

export default forwardRef((p: Props, ref) => {
  const [checked, setChecked] = useState(p.checkedState ?? false)

  // Ref методы
  useImperativeHandle(ref, () => ({
    reset() {
      setChecked(false)
      sendOutput(p.noodlNode, 'checked', false)
      sendSignal(p.noodlNode, 'reseted')
    },
  }))

  // Обновление при изменении checkedState
  useEffect(() => {
    if (p.checkedState !== checked) {
      setChecked(p.checkedState)
    }
  }, [p.checkedState])

  // Выходные сигналы
  useEffect(() => {
    sendOutput(p.noodlNode, 'checked', checked)
    sendSignal(p.noodlNode, 'changed')
  }, [checked])
  return (
    <Switch
      checked={p.inGroup ? undefined : checked}
      onChange={
        p.inGroup ? undefined : (e) => setChecked(e.currentTarget.checked)
      }
      thumbIcon={
        checked ? p.checkedThumbIcon && <IconSvg iconName={p.checkedThumbIcon} iconSize='12' iconColor={p.checkedThumbColor} iconStroke='3' />
          : p.notCheckedThumbIcon && <IconSvg iconName={p.notCheckedThumbIcon} iconSize='12' iconColor={p.notCheckedThumbColor} iconStroke='3' />
      }
      {...p}
      {...p.customProps}
      styles={{
        track: {
          borderRadius: p.radius,
        },
        thumb: {
          borderRadius: p.radius,
        },
      }}

    />
  )
})
